import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { QuestionGroupModel } from '../model/question-group.model';

@Injectable()
export class QuestionGroupService {

    path = '/question-group';

    constructor(private baseService: BaseService) {}

    save(questionGroup: QuestionGroupModel) {
        if (questionGroup.id) { return this.put(questionGroup); } else { return this.post(questionGroup); }
    }

    post(questionGroup: QuestionGroupModel) {
        return this.baseService.post(this.path, '/', questionGroup);
    }

    put(questionGroup: QuestionGroupModel) {
        return this.baseService.put(this.path, '/', questionGroup);
    }

    delete(id: number) {
        return this.baseService.delete(this.path, '/' + id);
    }

    findById(id: number) {
        return this.baseService.get(this.path, '/' + id);
    }
    
    findByChecklistId(checklistId: number) {
        return this.baseService.get(this.path, '/by-checklist/' + checklistId);
    }

    saveInChecklist(questions: QuestionGroupModel[], checklist_id) {
        return this.baseService.post(this.path, '/in-checklist/' + checklist_id, questions);
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/question-group.service.ts